import { MouseEvent } from 'react';
import * as S from './styles';

interface Props {
  letter: string;
  'data-testid'?: string;
  disabled?: boolean;
  onClick: (letter: string) => void;
  showBigger: boolean;
  onVideo?: boolean;
}

const KeyboardKey = ({
  disabled,
  letter,
  'data-testid': dataTestId,
  onClick,
  showBigger,
  onVideo = false,
}: Props) => (
  <S.Button
    {...{ disabled }}
    data-testid={dataTestId || null}
    onClick={() => onClick(letter)}
    onMouseDown={(event: MouseEvent) =>
      event.preventDefault()
    } /* prevent mouse grabbing focus, as flickers with input control regaining focus after */
    $showBigger={showBigger}
    $onVideo={onVideo}
  >
    {letter}
  </S.Button>
);

export default KeyboardKey;
